import { connect } from 'react-redux';
import Component from './FanFeedRoot';
import { setHeaderTitle } from '../../../actions/layout';
import { listStateFromCRUD } from '../../../selectors/crud';
import {
  ROUTE_FAN_FEED_POSTS_ROOT,
  ROUTE_FAN_FEED_TAGS_ROOT,
  ROUTE_FAN_FEED_TAGS_NEW,
  ROUTE_FAN_FEED_SLIDESHOW
} from '../constants';
import { push } from 'react-router-redux/lib/actions';

export default connect(
  ({ fan_feed_tags, fan_feed_posts, fan_feed_slideshow }) => ({
    fanFeed: { ...listStateFromCRUD(fan_feed_posts) },
    fanFeedTags: { ...listStateFromCRUD(fan_feed_tags) },
    fanFeedSlideShow: { ...listStateFromCRUD(fan_feed_slideshow) },
  }),
  dispatch => {
    return {
      updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
      goToTags: () => dispatch(push(ROUTE_FAN_FEED_TAGS_ROOT)),
      goToPosts: () => dispatch(push(ROUTE_FAN_FEED_POSTS_ROOT)),
      goToSlideShow: () => dispatch(push(ROUTE_FAN_FEED_SLIDESHOW)),
      addTag: () => dispatch(push(ROUTE_FAN_FEED_TAGS_NEW))
    }
  },
)(Component);



// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedRoot/index.tsx